module.exports = __webpack_public_path__ + "static/media/delete-policy.2c53b9ed.jpg";